import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/FeaturesCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de470bb10599dc/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/sections/InternalLinksSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de470bb10599dc/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFeatures"] */ "/tmp/8de470bb10599dc/components/sections/KioskFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCaseStudy"] */ "/tmp/8de470bb10599dc/components/sections/QRCaseStudy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRLocations"] */ "/tmp/8de470bb10599dc/components/sections/QRLocations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRShowcase"] */ "/tmp/8de470bb10599dc/components/sections/QRShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/node_modules/next/dist/client/link.js");
